<div class="sms-dialog-wrapper">
  <div class="dialog-header">
    <div class="header-title">
      <mat-icon>chat</mat-icon>
      <span>SMS Activity Details</span>
    </div>
  </div>

  <div class="dialog-body">
    <div class="details-row">
      <div class="detail-item">
        <div class="detail-label">SENT DATE/TIME</div>
        <div class="detail-value">{{ formatDateTime(data.createdAt) }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">SMS TYPE</div>
        <div class="detail-value">{{ data.smsType || 'N/A' }}</div>
      </div>
    </div>

    <div class="details-row">
      <div class="detail-item">
        <div class="detail-label">RECIPIENT</div>
        <div class="detail-value">{{ data.sendTo || 'N/A' }}</div>
      </div>
      <div class="detail-item">
        <div class="detail-label">SENDER</div>
        <div class="detail-value">{{ data.sendby || 'N/A' }}</div>
      </div>
    </div>

    <div class="details-row border-bottom">

      <div class="detail-item">
        <div class="detail-label">STATUS</div>
        <div class="detail-value">
          <span class="status-badge" [class.success]="data.status === 200" [class.failed]="data.status !== 200">
            {{ getStatusText() }}
          </span>
        </div>
      </div>
    </div>

    <div class="message-section">
      <div class="detail-label">MESSAGE CONTENT</div>
      <div class="message-box">{{ data.description || 'N/A' }}</div>
    </div>

    <div class="response-section">
      <div class="detail-label">SMS VENDOR RESPONSE</div>
      <div class="response-text" [class.success]="data.status === 200" [class.failed]="data.status !== 200">
        <mat-icon>{{ data.status === 200 ? 'check_circle' : 'error' }}</mat-icon>
        <span>{{ getResponseMessage() }}</span>
      </div>
    </div>
  </div>

  <div class="dialog-footer">
    <button mat-stroked-button (click)="onClose()">Close</button>
  </div>
</div>